import { withMemberContext } from '@/config/site'
import request from '@/utils/request'

export const fetchMemberNotes = async (payload = {}) => {
  const response = await request('/page/note/index', {
    data: withMemberContext(payload)
  })

  const data = response.data || {}
  if (Array.isArray(data)) {
    return {
      list: data,
      total: data.length,
      page: payload.page || 1,
      page_size: payload.page_size || data.length
    }
  }

  return {
    list: Array.isArray(data.list) ? data.list : [],
    total: Number(data.total) || 0,
    page: Number(data.page) || Number(payload.page) || 1,
    page_size: Number(data.page_size) || Number(payload.page_size) || 20
  }
}

export const fetchMemberNoteDetail = async (id, payload = {}) => {
  const response = await request('/page/note/detail', {
    data: withMemberContext({
      id,
      ...payload
    })
  })

  return response.data || {}
}

export const saveMemberNote = async (payload = {}) => {
  const response = await request('/page/note/store', {
    data: withMemberContext(payload)
  })

  return response.data || {}
}

export const removeMemberNote = async (id, payload = {}) => {
  const response = await request('/page/note/remove', {
    data: withMemberContext({
      id,
      ...payload
    })
  })

  return response.data || []
}
